import { render, staticRenderFns } from "./ResidentHistoryWidget.vue?vue&type=template&id=6d9f9ad9&scoped=true&"
import script from "./ResidentHistoryWidget.vue?vue&type=script&lang=ts&"
export * from "./ResidentHistoryWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentHistoryWidget.vue?vue&type=style&index=0&id=6d9f9ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f9ad9",
  null
  
)

export default component.exports